<template>
	<div class="yj-verify">
		<div class="word-embed" v-if="trigger === 'embed'">
			<div class="embed">
				<div class="panel">
					<div class="imgarea" ref="imgArea">
						<div class="bgimg" v-if="!loading">
							<img class="bg-img" :src="picture" @click.stop="doPoint" ref="bgImg" />
							<div class="point" v-for="p,index in points" :key="index" :style="{left: p.x+'px',top: p.y +'px'}" @click="removePoint(index)">{{index+1}}</div>
						</div>
						<div class="loadbox">
							<div class="loadbox__inner" v-if="loading">
								<i class="yj-icon-loading"></i>
								<span class="loadtext">加载中...</span>
							</div>
						</div>
						<div class="top" v-if="result !== 'success'">
							<div class="refresh">
								<i class="yj-icon-refresh" :class="getRefreshIconClass" @click="refresh"></i>
							</div>
						</div>
					</div>
				</div>
				<div class="control" :class="result">
					<div class="tips">
						<span class="tips__icon" v-html="getIcon"></span>
						<span class="tips__text fallback__tip">{{ getTipText }}</span>
						<div class="tips__answer" :style="getAnswerClass">
							<span class="tips__point">{{formatWords() }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="word-dialog" :style="getDialogStyle" v-else-if="trigger === 'dialog'">
			<div class="dialog">
				<div class="title">请完成安全验证<i class="yj-icon-small-close" @click="hide"></i></div>
				<div class="panel">
					<div class="imgarea" ref="imgArea">
						<div class="bgimg" v-if="!loading">
							<img class="bg-img" :src="picture" @click.stop="doPoint" ref="bgImg" />
							<div class="point" v-for="p,index in points" :key="index" :style="{left: p.x+'px',top: p.y +'px'}" @click="removePoint(index)">{{index+1}}</div>
						</div>
						<div class="loadbox">
							<div class="loadbox__inner" v-if="loading">
								<i class="yj-icon-loading"></i>
								<span class="loadtext">加载中...</span>
							</div>
						</div>
						<div class="top" v-if="result !== 'success'">
							<div class="refresh">
								<i class="yj-icon-refresh" :class="getRefreshIconClass" @click="refresh"></i>
							</div>
						</div>
					</div>
				</div>
				<div class="control" :class="result">
					<div class="tips">
						<span class="tips__icon" v-html="getIcon"></span>
						<span class="tips__text fallback__tip">{{ getTipText }}</span>
						<div class="tips__answer" :style="getAnswerClass">
							<span class="tips__point">{{formatWords() }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="word-trigger" v-else-if="trigger === 'hover'">
			<div class="trigger" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
				<transition name="yj-zoom-in-bottom">
					<div class="panel" v-show="on" >
						<div class="imgarea" ref="imgArea">
							<div class="bgimg" v-if="!loading">
								<img class="bg-img" :src="picture" @click.stop="doPoint" ref="bgImg" />
								<div class="point" v-for="(p, index) in points" :key="index" :style="{left: p.x+'px',top: p.y +'px'}" @click="removePoint(index)">{{index+1}}</div>
							</div>
							<div class="loadbox">
								<div class="loadbox__inner" v-if="loading">
									<i class="yj-icon-loading"></i>
									<span class="loadtext">加载中...</span>
								</div>
							</div>
							<div class="top" v-if="result !== 'success'">
								<div class="refresh">
									<i class="yj-icon-refresh" :class="getRefreshIconClass" @click="refresh"></i>
								</div>
							</div>
						</div>
					</div>
				</transition>
				<div class="control" :class="result">
					<div class="tips" :style="getTipsStyle">
						<span class="tips__icon" v-html="getIcon"></span>
						<span class="tips__text fallback__tip">{{ getTipText }}</span>
						<div class="tips__answer" :style="getAnswerClass">
							<span class="tips__point">{{formatWords() }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'YjWordVerify',

		props: {
			trigger: {
				type: String,
				default: 'embed'
			},
			picture: {
				type: String,
				required: true
			},
			words: {
				type: Array,
				required: true
			},
			loading: {
				type: Boolean,
				default: true
			},
		},

		data() {
			return {
				points: [],
				result: '',
				on: false,
				visible: false,
				zIndex: 0,
			};
		},

		computed: {
			getRefreshIconClass() {
				return this.loading ? 'curn' : 'curp';
			},
			getAnswerClass() {
				if(this.trigger === 'hover') {
					if (!this.on || this.loading || this.result !== '') {
						return 'display: none';
					} else {
						return 'display: inline-block';
					}
				} else {
					if (this.loading || this.result !== '') {
						return 'display: none';
					} else {
						return 'display: inline-block';
					}
				}
			},
			getTipText() {
				if(this.trigger === 'hover') {
					if(!this.on && this.result === ''){
						return '点击此处验证'
					}else{
						if(this.loading) {
							return '加载中...';
						} else {
							if(this.result === '') {
								return '请依次点击';
							} else if(this.result === 'success') {
								return '验证成功';
							} else if(this.result === 'failed') {
								return '验证失败，请重试';
							} else if(this.result === 'check') {
								return '验证中...';
							}
						}
					}
				} else {
					if (this.loading) {
						return '加载中...';
					} else {
						if (this.result === '') {
							return '请依次点击';
						} else if (this.result === 'success') {
							return '验证成功';
						} else if (this.result === 'failed') {
							return '验证失败，请重试';
						} else if (this.result === 'check') {
							return '验证中...';
						}
					}
				}
			},
			getIcon() {
				if(this.trigger === 'hover') {
					if(!this.on && this.result === ''){
						return '<i class="yj-icon-small-clock"></i>'
					}else{
						if(this.loading) {
							return '';
						} else {
							if(this.result === '') {
								return '';
							} else if(this.result === 'success') {
								return '<i class="yj-icon-small-sure"></i>';
							} else if(this.result === 'failed') {
								return '<i class="yj-icon-small-close"></i>';
							}
						}
					}
				} else {
					if (this.loading) {
						return '';
					} else {
						if (this.result === '') {
							return '';
						} else if (this.result === 'success') {
							return '<i class="yj-icon-small-sure"></i>';
						} else if (this.result === 'failed') {
							return '<i class="yj-icon-small-close"></i>';
						}
					}
				}
				
			},
			getTipsStyle(){
				if(!this.on && this.result === ''){
					return 'cursor: pointer;';
				}
			},
			getDialogStyle(){
				return this.visible ? `display:block;z-index:${this.zIndex};` : `display:none;z-index:${this.zIndex}`;
			},
		},

		methods: {
			/**
			 * description： 打开验证弹出窗
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			show(){
				if(this.trigger !== 'dialog') return;
				
				let parent = this.$el.parentNode;
				
				if(parent.querySelector('.yj-verify-mask') == null){
					// 给父节点增加position relative属性
					parent.style.position = 'relative';
				
					// 父节点的层级
					let zIndex = parent.style.zIndex || 0;
					// 创建遮罩层el
					let div = document.createElement('div');
					div.style.display = "block";
					div.style.zIndex = zIndex+1;
					div.className = "yj-verify-mask";
					// 加入到父节点中
					parent.appendChild(div);
					//弹出窗层级别遮罩层多1
					this.zIndex = zIndex+2;
				}else{
					parent.querySelector('.yj-verify-mask').style.display = "block";
				}
				
				// 在父节点添加遮罩层
				this.visible = true;
			},
			/**  
			 * description： 关闭验证弹出窗
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			hide(){
				if(this.trigger !== 'dialog') return;
				// 父节点
				let parent = this.$el.parentNode;;
					
				parent.querySelector('.yj-verify-mask').style.display = "none";
				
				this.visible = false;
			},
			/**
			 * description： 鼠标移入显示图片
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			mouseEnter(){
				if(this.result === 'success'){
					return;
				}
				
				this.on = true;
			},
			/**  
			 * description： 鼠标移出隐藏图片
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			mouseLeave(){
				if(this.result === 'success'){
					return;
				}
				
				this.on = false;
			},
			/**  
			 * description： 格式化要点击的字
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			formatWords() {
				let words = '';

				// 处理文字格式
				if (this.words && this.words.length) {
					for (let i = 0; i < this.words.length; i++) {
						words += '"' + this.words[i] + '"';

						if (i != this.words.length - 1) {
							words += ' ';
						}
					}
				}

				return words;
			},
			/**  
			 * description： 刷新图片
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			refresh() {
				// 加载过程中禁止点击
				if (this.loading) {
					return;
				}

				// 清除图片上的标记点
				this.points = [];
				// 清除校验状态
				this.result = '';

				// 通知父组件刷新图片
				this.$emit('refresh');
			},
			/**  
			 * description： 增加图片锚点
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			doPoint(e) {
				if (this.points.length === this.words.length) {
					return;
				}

				// 获取图片元素，主要取鼠标点击的位置数据
				let imgEL = this.$refs.bgImg;

				// 图片元素必须存在
				if (imgEL != undefined) {
					// 如果标记个数小于文字个数
					if (this.points.length < this.words.length) {
						let points = this.getXAndY(e);
						// 增加标记
						this.points.push({
							x: points.x - 12, // 12表示半个标记的宽度
							y: points.y - 12, // 12表示半个标记的高度
						});
					}

					// 如果标记点已经和文字数量一致
					if (this.points.length === this.words.length) {
						this.result = 'check';
						// 等待最后一个标记渲染完
						this.$nextTick(() => {
							// 通知父组件校验
							this.$emit('check', this.points, this.checkCallback);
						});
					}
				}
			},
			/**  
			 * description： 获取鼠标点击区域中的相对位置坐标
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			getXAndY(event) {
				//鼠标点击的绝对位置
				event = event || window.event;
				let mousePos = this.mouseCoords(event);
				let x = mousePos.x;
				let y = mousePos.y;
				//获取图片容器在body中的绝对位置
				let x1 = this.$refs.imgArea.getBoundingClientRect().left;
				let y1 = this.$refs.imgArea.getBoundingClientRect().top;

				//鼠标点击位置相对于图片容器的坐标
				let x2 = x - x1;
				let y2 = y - y1;

				return {
					x: x2,
					y: y2
				};
			},
			/**  
			 * description： 获取鼠标点击区域在Html绝对位置坐标
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			mouseCoords(event) {
				if (event.pageX || event.pageY) {
					return {
						x: event.pageX,
						y: event.pageY
					};
				}

				return {
					x: event.clientX + document.body.scrollLeft - document.body.clientLeft,
					y: event.clientY + document.body.scrollTop - document.body.clientTop
				};
			},
			/**  
			 * description： 校验结果展示
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			checkCallback(val) {
				if (val === 'success' || val === 'failed') {
					this.result = val;
				}

				// 如果验证失败，刷新验证码
				if (val === 'failed') {
					if (this.st) {
						clearTimeout(this.st);
					}
					this.$nextTick(() => {
						this.st = setTimeout(() => {
							this.refresh();
						}, 1000);
					});

				}else{
					if(this.trigger === 'dialog') {
						if (this.st) {
							clearTimeout(this.st);
						}
						this.$nextTick(() => {
							this.st = setTimeout(() => {
								this.hide();
								this.$emit('success');
							}, 1000);
						});
					}else if(this.trigger === 'hover') {
						if (this.st) {
							clearTimeout(this.st);
						}
						this.$nextTick(() => {
							this.st = setTimeout(() => {
								this.on = false;
								this.$emit('success');
							}, 1000);
						});
					} else{
						this.$emit('success');
					}
					
				}
			},
			/**  
			 * description： 移除点
			 * @param {Number} index 被移除的点
			 *
			 * created by hezq on 2019-10-30
			 *
			 */
			removePoint(index) {
				if (this.result !== '') {
					return;
				}
				if (index === this.points.length - 1) {
					this.points.splice(index, 1);
				}
			}
		},
	}
</script>



// WEBPACK FOOTER //
// src/components/word-verify/src/word-verify.vue